module.exports = __webpack_public_path__ + "img/SpaceCode_AstroWin.47371206.svg";